import {
    AfterViewChecked,
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    Output,
    ViewChild
} from '@angular/core';
import {CarTemplateListCardMessage} from "./car-template-list-card-message";

@Component({
    selector: 'car-template-list-card',
    templateUrl: './car-template-list-card.component.html'
})
export class CarTemplateListCardComponent implements AfterViewChecked{

    @Input() listCard: CarTemplateListCardMessage;
    @Input() cardHeight: number;

    @Output() remove:EventEmitter<any> = new EventEmitter<any>();
    @Output() edit:EventEmitter<any> = new EventEmitter<any>();

    public collapsed:boolean = true;
    private padding: number = 55;
    private cardMaxHeight:number;

    @ViewChild('content')content: ElementRef;

    constructor(private changeDetectorRef:ChangeDetectorRef) {
    }

    ngAfterViewChecked(): void {
        this.cardMaxHeight = this.content.nativeElement.scrollHeight;
        this.changeDetectorRef.detectChanges();
    }

    showMoreButtons(): boolean{
        return (this.cardHeight + this.padding) < this.cardMaxHeight;
    }

    editCallback(){
        this.edit.next();
    }

    removeCallback(){
        this.remove.next();
    }
}


// WEBPACK FOOTER //
// ./public/upgrade/feature/carTemplate/list/card/car-template-list-card.component.ts